import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useCreateDirectConversationMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createDirectConversation(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.conversations() });
		}
	});
};
//#endregion
export { i as useCreateDirectConversationMutation };
